/* eslint-disable no-shadow */
export enum MessageType {
    success = 'success',
    danger = 'danger',
    warning = 'warning',
    info = 'info'

}
